import { track } from '@betterment/js-runtime';
import { Controller } from 'stimulus';

import ProjectionGraph, { ProjectionGraphOptions } from '../graphs/projection-graph';

export default class extends Controller {
  static targets = ['container', 'svg'];

  containerTarget: HTMLElement;

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new ProjectionGraph(this.containerTarget, this.svgTarget, this.graphOptions);
    chart.draw();
  }

  mouseLeave() {
    this.trackHover();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  trackHover() {
    track('ElementHovered', { name: 'ProjectionGraph', location: this.data.get('tracking-location')! });
  }

  get graphOptions(): ProjectionGraphOptions {
    return JSON.parse(this.data.get('data') || '{}') as ProjectionGraphOptions;
  }
}
